import { LuneThemeNew } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import { FC } from 'react'

const { palette } = LuneThemeNew

const AccountNameAndLogoTile: FC<{
    accountName: string
    logo?: string | null
}> = ({ accountName, logo }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
            }}
        >
            <Box
                sx={{
                    borderRadius: '100%',
                    width: '40px',
                    height: '40px',
                    flex: '1 0 auto',
                    border: logo ? `1px solid ${palette.Surface400}` : 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    img: {
                        maxWidth: '30px',
                        maxHeight: '30px',
                        width: 'auto',
                        height: 'auto',
                    },
                }}
            >
                {logo ? (
                    <img src={logo} alt={`${accountName}'s logo`} />
                ) : (
                    <Box
                        sx={{
                            width: '40px',
                            height: '40px',
                            backgroundColor: palette.Surface700,
                            color: palette.White,
                            fontSize: '16px',
                            fontWeight: '500',
                            lineHeight: '40px',
                            textAlign: 'center',
                        }}
                    >
                        {accountName[0]}
                    </Box>
                )}
            </Box>
            {accountName}
        </Box>
    )
}

export default AccountNameAndLogoTile
